export enum KalenderRechte {
    kalenderAnzeigen = 4521,
    urlaubGenehmigen = 4525,
    wochenendeFeiertagePlanen = 4528,
    krankheitMelden = 4526,
    antragAnlegenEditieren = 4522,
    antragAndererBenutzer = 4527,
}
